/**
 * Returns true if a participant is a registered user
 * @param {object} participant Participant data
 * @returns boolean
 */
export function isParticipantUser(participant) {
    return !!participant.user_id;
}
